export const dashboardRoutes = [
  {
    path: "/dashboards/wizard",
    lazy: () =>
      import("../../modules/home/wizard/DashboardWizard").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/genres",
    lazy: () =>
      import("../../modules/dashboards/genre-dashboard").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/netflix",
    lazy: () =>
      import("../../modules/dashboards/netflix-dashboard/").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/pantheonranking",
    lazy: () =>
      import("../../modules/ranking/trending/pantheon-ranking/TrendingPantheonRankingIndex").then(
        (m) => ({ Component: m.TrendingPantheonRankingIndex }),
      ),
  },
  {
    path: "/dashboards/jwstreaming",
    lazy: () =>
      import("../../modules/dashboards/jwstreamingcharts/").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/nonott",
    lazy: () =>
      import("../../modules/dashboards/nonott-dashboard/").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/top_lists/webtoons",
    lazy: () =>
      import("../../modules/dashboards/trendingcharts/webtoons/").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/top_lists/roblox",
    lazy: () =>
      import("../../modules/dashboards/trendingcharts/roblox/").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/dashboards/top_lists/royal_road",
    lazy: () =>
      import("../../modules/dashboards/trendingcharts/royal_road/").then(
        (m) => ({
          Component: m.default,
        }),
      ),
  },
  {
    path: "/dashboards/top_lists/theme_park_waits",
    lazy: () =>
      import("../../modules/dashboards/trendingcharts/thrill_data/").then(
        (m) => ({
          Component: m.default,
        }),
      ),
  },
  {
    path: "/dashboards/news",
    lazy: () =>
      import("../../modules/dashboards/news-dashboard").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/pulse",
    lazy: () =>
      import("../../modules/pulse").then((m) => ({ Component: m.default })),
  },
  {
    path: "/pulse/:sessionId",
    lazy: () =>
      import("../../modules/pulse").then((m) => ({ Component: m.default })),
  },
];
